module.exports = __webpack_public_path__ + "static/features-84c84199ea3e9a7341265fae39124cef.png";